import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TLocaleCode } from '@treezor/design-system';

import { TI18nLocales, i18nToIntl } from '@/utils/constants';

export const useI18nLocale = () => {
  const { i18n } = useTranslation();
  const locale = useMemo(() => i18n.language as TLocaleCode, [i18n.language]);

  return locale;
};

export const useIntlLocale = (): TI18nLocales => {
  const { i18n } = useTranslation();
  const locale = useMemo(() => {
    const i18nLocale = i18n.language;
    return i18nToIntl[i18nLocale];
  }, [i18n.language]);
  return locale;
};
